import React from "react";
import AntdTable from "../../../components/common/AntdTable";
import PrintOutHeader from "../../../components/shared/PrintOutHeader";
import useMonthlyPayslipStore from "../../../config/stores/administration/useMonthlyPayslipStore";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import { inputNumberFormatter } from "../../../config/constants";

const PrintPayslip = () => {
  const payslipStore = useMonthlyPayslipStore();

  const { payslipDetails } = payslipStore;
  const month = dayjs(`${payslipDetails?.month}`).format("MMMM");

  const approvedAt = dayjs(payslipDetails?.approved_at);
  const checkedAt = dayjs(payslipDetails?.checked_at);

  return (
    <div>
      <AntdTable
        title={() => <PrintOutHeader />}
        className="mb-1"
        showHeader={false}
        columns={[
          { dataIndex: "column" },
          {
            dataIndex: "value",
            render: (value) => (
              <span className="text-uppercase fw-bold">{value}</span>
            ),
          },
        ]}
        data={[
          {
            column: "PERIOD",
            value: `${month} ${payslipDetails.year}`,
          },
          {
            column: "NAME OF STAFF",
            value: `${payslipDetails?.user?.first_name || ""} ${
              payslipDetails?.user?.other_names || ""
            }`,
          },
          {
            column: "POSITION",
            value: payslipDetails?.staff_contract?.position || "",
          },
          {
            column: "STATUS",
            value: payslipDetails?.status || "",
          },
                                {
             column: "CHECKED AT",
             value: payslipDetails?.checked_at && checkedAt.isValid()
               ? checkedAt.format("DD/MM/YYYY HH:mm")
               : "NOT CHECKED",
           },
           {
             column: "CHECKED BY",
             value: payslipDetails?.checked_by 
               ? `${payslipDetails.checked_by.first_name || ""} ${payslipDetails.checked_by.other_names || ""}`
               : "NOT CHECKED",
           },
           {
             column: "APPROVED AT",
             value: payslipDetails?.approved_at && approvedAt.isValid()
               ? approvedAt.format("DD/MM/YYYY HH:mm")
               : "NOT APPROVED",
           },
           {
             column: "APPROVED BY",
             value: payslipDetails?.approved_by 
               ? `${payslipDetails.approved_by.first_name || ""} ${payslipDetails.approved_by.other_names || ""}`
               : "NOT APPROVED",
           },
        ]}
      />

      {/* Payslip Details Table */}
      <div className="mt-4">
        <h5 className="text-center fw-bold mb-3">PAYSLIP DETAILS</h5>
        
        {/* Working Days Summary */}
        <div className="row mb-3">
          <div className="col-12">
            <table className="table table-bordered table-sm">
              <thead className="table-dark">
                <tr>
                  <th colSpan="4" className="text-center">WORKING DAYS SUMMARY</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="fw-bold">Total Working Days</td>
                  <td>{payslipDetails?.total_working_days || 0}</td>
                  <td className="fw-bold">NSSF Number</td>
                  <td>{payslipDetails?.nssf_number || "N/A"}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Paid Days</td>
                  <td>{payslipDetails?.paid_days || 0}</td>
                  <td className="fw-bold">Loss of Pay (LOP) days</td>
                  <td>{payslipDetails?.lop_days || 0}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Leaves Taken</td>
                  <td>{payslipDetails?.leaves_taken || 0}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Earnings and Deductions */}
        <div className="row">
          <div className="col-md-6">
            <table className="table table-bordered table-sm">
              <thead className="table-success">
                <tr>
                  <th colSpan="2" className="text-center">EARNINGS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="fw-bold">Gross Pay</td>
                  <td className="text-end">UGX {inputNumberFormatter(payslipDetails?.gross_pay || 0)}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Transport Allowance</td>
                  <td className="text-end">UGX {inputNumberFormatter(payslipDetails?.transport_allowance || 0)}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Housing Allowance</td>
                  <td className="text-end">UGX {inputNumberFormatter(payslipDetails?.housing_allowance || 0)}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Medical Allowances</td>
                  <td className="text-end">UGX {inputNumberFormatter(payslipDetails?.medical_allowances || 0)}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Other Allowances</td>
                  <td className="text-end">UGX {inputNumberFormatter(payslipDetails?.other_allowances || 0)}</td>
                </tr>
                <tr className="table-active">
                  <td className="fw-bold">TOTAL EARNINGS</td>
                  <td className="text-end fw-bold">UGX {inputNumberFormatter(payslipDetails?.total_earnings || 0)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-md-6">
            <table className="table table-bordered table-sm">
              <thead className="table-danger">
                <tr>
                  <th colSpan="2" className="text-center">DEDUCTIONS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="fw-bold">NSSF (15%)</td>
                  <td className="text-end">UGX {inputNumberFormatter(payslipDetails?.nssf_deduction || 0)}</td>
                </tr>
                <tr>
                  <td className="fw-bold">PAYE</td>
                  <td className="text-end">UGX {inputNumberFormatter(payslipDetails?.paye || 0)}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Local Service Tax</td>
                  <td className="text-end">UGX {inputNumberFormatter(payslipDetails?.local_service_tax || 0)}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Salary Advance</td>
                  <td className="text-end">UGX {inputNumberFormatter(payslipDetails?.salary_advance || 0)}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Staff Savings Scheme</td>
                  <td className="text-end">UGX {inputNumberFormatter(payslipDetails?.staff_savings_scheme || 0)}</td>
                </tr>
                <tr className="table-active">
                  <td className="fw-bold">TOTAL DEDUCTIONS</td>
                  <td className="text-end fw-bold">UGX {inputNumberFormatter(payslipDetails?.total_deductions || 0)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Net Salary */}
        <div className="row mt-3">
          <div className="col-12">
            <table className="table table-bordered table-sm">
              <tbody>
                <tr className="table-primary">
                  <td className="fw-bold text-center" style={{ fontSize: '1.2em' }}>
                    NET SALARY
                  </td>
                  <td className="text-end fw-bold" style={{ fontSize: '1.2em' }}>
                    UGX {inputNumberFormatter(payslipDetails?.net_salary || 0)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer Information */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="text-center">
              <p className="mb-1">
                <strong>This payslip is computer generated and does not require a signature.</strong>
              </p>
              <p className="mb-1">
                Generated on: {dayjs().format("DD/MM/YYYY HH:mm")}
              </p>
              <p className="mb-0">
                For any queries, please contact the HR department.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintPayslip; 